<section class="cta-box w-full relative overflow-hidden rounded-[28px] px-8 md:px-16 py-10 md:py-[72px] text-center">
  <!-- Background image -->
  <app-responsive-img
    name="cta-bg"
    alt=""
    imgClass="absolute inset-0 w-full h-full object-cover z-0"
    sizes="100vw"
  />

  <!-- Content -->
  <div class="relative z-10">
    <h2 class="text-[28px] md:text-[36px] lg:text-[40px] font-extrabold text-white leading-tight mb-4"
        [innerHTML]="'talentSearchV2.cta.title' | translate | accent">
    </h2>

    <p class="text-base text-white/50 leading-[1.75] mb-9 mx-auto max-w-lg">
      {{ 'talentSearchV2.cta.subtitle' | translate }}
    </p>

    <div class="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
      <button
        type="button"
        (click)="openBookDemo()"
        class="inline-flex items-center gap-2 rounded-full bg-[#2AED73] px-8 py-4 text-sm font-semibold text-[#061430] shadow-[0_4px_16px_0_rgba(76,234,99,0.3)] transition-opacity hover:opacity-90"
      >
        {{ 'talentSearchV2.cta.primaryButton' | translate }}
        <span class="inline-grid place-items-center rtl:flip"><app-icon name="tabler:arrow-narrow-right" [size]="18"/></span>
      </button>
      <button
        type="button"
        (click)="openBookDemo()"
        class="inline-flex items-center rounded-full border-[1.5px] border-white/25 bg-transparent px-8 py-4 text-sm font-semibold text-white transition-all hover:border-white/40"
      >
        {{ 'talentSearchV2.cta.secondaryButton' | translate }}
      </button>
    </div>

    <p class="text-xs text-white/40 tracking-wide">
      {{ 'talentSearchV2.cta.bottomNote' | translate }}
    </p>
  </div>
</section>
